module.exports = __webpack_public_path__ + "img/2.244152e9.png";